import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"enable-background":"new 0 0 10 9"},
  viewBox: "0 0 10 10"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1 1h8v8H1z",
  style: {"fill":"none","stroke":"#6c7580","stroke-width":".5","stroke-miterlimit":"10"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1 3h8M1 5h8M4.7 1v2M4.7 5v2M1 7h8",
  style: {"fill":"none","stroke":"#6c7580","stroke-width":".25","stroke-miterlimit":"10"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.2 3v2M3.2 7v2M7.2 3v2M7.2 7v2",
  style: {"fill":"none","stroke":"#6c7580","stroke-width":".25","stroke-linecap":"square","stroke-miterlimit":"10"}
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }